{
  "organization": "Organization",
  "tabs": {
    "apiTokens": "API Tokens",
    "embeddedWebApp": "Embedded WebApp",
    "integrations": "Integrations",
    "webHooks": "Webhooks"
  },
  "apiTokenTable": {
    "name": "Name",
    "noPermissions": "# of Permissions",
    "organization": "Organization",
    "state": "State",
    "actions": "Actions"
  },
  "apiTokenModal": {
    "title": "Create new API Token",
    "name": "Name",
    "organization": "Organization",
    "permissions": "Permissions"
  },
  "viewApiToken": "View Authorization Header",
  "deactivate": "Deactivate",
  "deactivated": "Deactivated",
  "active": "Active",
  "update": "Update",
  "edit": "Edit",
  "cancel": "Cancel",
  "editApiTokenModal": {
    "title": "Edit API Token",
    "save": "Save"
  },
  "orgInfo": {
    "organizationId": "Organization ID",
    "partnerJWK": "Partner JWK",
    "webAppURL": "Web Application URL"
  },
  "integrationsTable": {
    "type": "Type",
    "name": "Name",
    "provider": "Provider",
    "organization": "Organization",
    "organizationSetting": "Organization Setting",
    "actions": "Actions",
    "state": "State",
    "active": "Active",
    "inactive": "Inactive"
  },
  "integrationsTableOptions": {
    "type": {
      "ADDRESS": "Address",
      "ANALYTICS": "Analytics",
      "BANKING": "Banking",
      "FINANCIAL_DATA_WIDGETS": "Financial Data Widgets",
      "ID_VERIFICATION": "ID Verification",
      "MARKET_DATA": "Market Data",
      "DATA_INGESTION": "Data Ingestion",
      "STATISTICS": "Statistics",
      "ACCOUNT_DETAILS": "Account details",
      "FORM": "Integration Forms",
      "CHAT_AGENT": "Chat Agent",
      "FRAUD_DETECTION": "Fraud Detection",
      "PASSTHROUGH_API": "Passthrough API",
      "ACCOUNT_OPENING": "Account Opening"
    },
    "default": "Default",
    "provider": {
      "CANADA_POST": "Canada Post",
      "FLINKS": "Flinks",
      "PLAID": "Plaid",
      "GOOGLE": "Google",
      "FIREBASE": "Firebase",
      "IEX_CLOUD": "IEX Cloud",
      "LSEG": "LSEG",
      "MIXPANEL": "Mixpanel",
      "PERSONA": "Persona",
      "QUOTE_MEDIA": "Quote Media",
      "ENVESTNET": "Envestnet",
      "ATB": "ATB",
      "ONESPAN": "ONESPAN",
      "DOCUSIGN": "DOCUSIGN",
      "ZENDESK": "ZENDESK",
      "SIMILITY": "SIMILITY",
      "SCHWAB": "Schwab",
      "none": "None",
      "NBIN": "NBIN"
    },
    "organizationSetting": {
      "notInherited": "Not Inherited",
      "inherited": "Inherited"
    },
    "viewDataIngestionRequests": "View Requests"
  },
  "integrationsModal": {
    "title": "Create new integration",
    "editTitle": "Edit Integration",
    "provider": "Provider",
    "type": "Type",
    "configuration": {
      "clientIframeUrl": "Client IFrame URL",
      "customerId": "Customer ID",
      "processorName": "Processor Name",
      "instanceId": "Instance ID",
      "plaidSecret": "Plaid Secret",
      "enableNameMatching": "Enable Name Matching",
      "templateId": "Template ID",
      "verificationPassedWebhookSecret": "Verification Passed Webhook Secret",
      "inquiryUpdateWebhookSecret": "Inquiry Update Webhook Secret",
      "accountBaseUri": "Account Base URI",
      "apiAccountId": "API Account ID",
      "accountUserId": "Account User ID",
      "integrationKey": "Integration Key",
      "integrationRsaPrivateKey": "Integration RSA Private Key",
      "connectSecretKey": "Docusign Connect Secret Key",
      "apiKey": "API Key",
      "apiToken": "API Token",
      "TBD": "TBD",
      "user": "User",
      "password": "Password",
      "baseUrl": "Base URL",
      "authDomain": "Auth Domain",
      "projectId": "Project ID",
      "messagingSenderId": "Messaging Sender ID",
      "appId": "App ID",
      "measurementId": "Measurement ID",
      "privateKey": "Private Key",
      "publicKey": "Public Key",
      "username": "Username",
      "name": "Name",
      "widgetUsername": "Widget API Username",
      "widgetName": "Widget API Name",
      "widgetPrivateKey": "Widget API Private Key",
      "widgetPublicKey": "Widget API Public Key",
      "rdpUsername": "RDP API Username",
      "rdpPassword": "RDP API Password",
      "rdpClientId": "RDP API Client ID",
      "webmasterId": "Webmaster ID",
      "clientRoleKey": "Client Role Key",
      "advisorRoleKey": "Advisor Role Key",
      "pageKeys": "Page Keys",
      "fnclsValue": "FNCLS Value",
      "scriptInjectURL": "Script Inject URL",
      "token": "Token",
      "netWorthAutomaticLinkingUrl": "Net Worth Automatic Linking URL",
      "netWorthAutomaticLinkingToken": "Net Worth Automatic Linking Token",
      "netWorthAutomaticLinkingNotificationGroup": "Net Worth Automatic Linking Notification Group",
      "senderEmail": "Sender Email",
      "packageNameTemplate": "Package Name template",
      "packageMetadataTemplate": "Package Metadata Object template",
      "masterAccountIds": "Master Account IDs",
      "enableSftp": "Enable SFTP",
      "sftpHost": "SFTP Host",
      "sftpPort": "SFTP Port",
      "sftpUsername": "SFTP Username",
      "sftpPassword": "SFTP Password",
      "sftpPrivateKey": "SFTP Private Key",
      "sftpPassphrase": "SFTP Passphrase",
      "sftpSendRootDir": "SFTP Send Root Directory",
      "sftpReceiveRootDir": "SFTP Receive Root Directory"
    },
    "attributes": {
      "passthroughApiUrl": "Passthrough API URL",
      "passthroughApiPrivateSecretName": "Variable name of the private key used to generate the Authorization token"
    },
    "scopeOptions": {
      "DATA_INGESTION": {
        "ORGANIZATION": "Organizations",
        "HOUSEHOLD": "Households",
        "ENTITY": "Entities",
        "ORGANIZATION_USER": "Auth Profiles",
        "ACCOUNT": "Accounts",
        "ACCOUNT_GROUP": "Account Groups",
        "SUB_ACCOUNT": "SubAccounts",
        "GOAL": "Goals",
        "TRANSACTION": "Transactions",
        "CASH_AND_HOLDINGS": "Cash and Holdings",
        "ASSET_CLASS": "Asset Classes",
        "FINANCIAL_PRODUCT": "Product Shelf",
        "MODEL_PORTFOLIO": "Model Porfolios",
        "STATS_HISTORY": "History snapshots",
        "PRICE_HISTORY": "Price snapshots",
        "PERFORMANCE_HISTORY": "Performance snapshots",
        "TRANSFER": "Transfers",
        "TRADE": "Trades",
        "SUB_TRADE": "SubTrades",
        "SCHEDULED_TRANSFER": "Scheduled Transfers",
        "CUSTODIAN_ACTIVITY": "Custodian Activities",
        "CUSTODIAN_CASH_AND_HOLDINGS": "Custodian Cash and Holdings",
        "BANK_ACCOUNT": "Bank Accounts"
      },
      "PASSTHROUGH_API": {
        "TRANSACTION": "Transactions",
        "CASH_AND_HOLDINGS": "Cash and Holdings",
        "STATS_HISTORY": "History snapshots",
        "PROJECTED_INCOME": "Projected Income",
        "PERFORMANCE": "Performance",
        "LIVE_PRICING": "Live Pricing",
        "HOUSEHOLD": "Households",
        "ENTITY": "Entities",
        "ACCOUNT": "Accounts",
        "PRODUCT_SHELF": "Product Shelf",
        "BANK_ACCOUNT": "Bank Account",
        "STATEMENT": "Statements"
      },
      "STATISTICS": {
        "holdings": "Holdings",
        "timeWeightedReturn": "Time-Weighted Rate of Return (TWRR)",
        "moneyWeightedReturn": "Money-Weighted Rate of Return (MWRR)",
        "simpleRateOfReturn": "Simple Rate of Return",
        "projectedIncome": "Projected Income",
        "historySnapshots": "History Snapshots",
        "contributions": "Contributions"
      }
    },
    "successToastMessage": "Integration has been successfully updated."
  },
  "integrationsDeleteModal": {
    "title": "Delete this integration?",
    "body": "Are you sure you want to delete this integration?"
  },
  "webHooksTable": {
    "type": "Type",
    "objects": "Objects",
    "organization": "Organization",
    "organizationSetting": "Organization Setting",
    "actions": "Actions"
  },
  "webHooksTableOptions": {
    "type": {
      "GRAPHQL": "GraphQL",
      "REST": "REST"
    },
    "objectType": {
      "Account": "Account",
      "AccountStatement": "Account Statement",
      "AdministrativeAnnualFeeReport": "Administrative Annual Fee Report",
      "BankAccount": "Bank Account",
      "ManagementAnnualFeeReport": "Management Annual Fee Report",
      "ScheduledTransfer": "Scheduled Transfer",
      "SubAccount": "SubAccount",
      "TaxSlip": "Tax Slip",
      "Transfer": "Transfer",
      "User": "User",
      "OrganizationUser": "Organization User",
      "BulkTradeRun": "Bulk Trade Run"
    }
  },
  "WebHookModal": {
    "title": "Create new webhook",
    "editTitle": "Edit webhook",
    "type": "Type",
    "organization": "Organization",
    "objectType": "Object Type",
    "customHeader": "Custom Header",
    "eventType": "Event Type",
    "graphQL": "GraphQL",
    "url": "URL",
    "payloadAttributes": "Payload Attributes",
    "signedJWTHeader": "Signed JWT Header",
    "mutationName": "Mutation Name",
    "mutationInputName": "Mutation Input Name",
    "customHeaderKey": "Custom Header Key",
    "customHeaderValue": "Custom Header Value",
    "payloadAttributeKey": "Payload Attribute Key",
    "payloadAttributeValue": "Payload Attribute Value",
    "successToastMessage": "WebHooks has been successfully updated.",
    "addAttributeBtn": "Add",
    "deleteSuccessToastMessage": "WebHook has been successfully deleted",
    "delete": "Delete",
    "deleteWebHookTitle": "Are you sure ?",
    "deleteWebHookBody": "You will not be able to recover this WebHook and will need to add another one."
  },
  "successToastMessage": "JWT Url has been successfully updated",
  "bulkUpsertRequest": {
    "table": {
      "objectType": "Object Type",
      "state": "State",
      "createdAt": "Ran At",
      "ranBy": "Ran By",
      "queuedItemsCount": "Queued",
      "failedItemsCount": "Failed",
      "processedItemsCount": "Processed"
    },
    "stateLabel": "State",
    "states": {
      "INITIATED": "Initiated",
      "PROCESSING": "Processing",
      "FAILED": "Failed",
      "PARTIALLY_FAILED": "Partially Failed",
      "CANCELED": "Canceled",
      "COMPLETED": "Completed"
    },
    "objectTypeLabel": "Type",
    "items": {
      "table": {
        "batchId": "Batch ID",
        "oneVestId": "OneVest ID",
        "externalId": "External ID",
        "state": "State"
      },
      "requestSummaryLine": "{{queued}} queued / {{processed}} processed / {{failed}} failed",
      "states": {
        "QUEUED": "Queued",
        "PROCESSED": "Processed",
        "FAILED": "Failed"
      },
      "upsertItemModal": {
        "title": "Item Details",
        "errorTitle": "Errors",
        "errorCode": "Code",
        "errorField": "Field",
        "errorDescription": "Description",
        "summary": {
          "oneVestId": "OneVest ID:",
          "batchId": "Batch ID:",
          "externalId": "External ID:"
        }
      }
    }
  }
}
